export const SET_COLLECTION		= "SET_COLLECTION";

export const actionSetCollection	= collection => ({ type: SET_COLLECTION, collection:collection });
